import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./index.css";
import "./FuturaFont/stylesheet.css";
import Home from "./Home";
import PushAds from "./Blog/PushAds";
import DicomBlogPost from "./Blog/Dicom";
import RadiologyViewer from "./Blog/RadiologyViewer";
import AgriApp from "./Blog/AgriApp";
import MainBlog from "./Blog/MainBlog";
import Header from "./Header/Header";
import Footer from "./Footer/Footer";
import { Analytics } from "@vercel/analytics/react";

ReactDOM.render(
  <div className="body">
    <Header />
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/blog/push-ads" element={<PushAds />} />
        <Route path="/blog/aws-dicom" element={<DicomBlogPost />} />
        <Route path="/blog/radiology-viewer" element={<RadiologyViewer />} />
        <Route path="/blog/agricultural-app" element={<AgriApp />} />
        <Route path="/blog" element={<MainBlog />} />
      </Routes>
    </BrowserRouter>
    <Footer />
    <Analytics />
  </div>,
  document.getElementById("root")
);
